import { APIService } from "../../../../network/api/APIService";


export const RegisterUser = (formData) => {
  return APIService({
      endpoint: "/authentication/register/",
      method: "POST",
      data: formData
  });
};